import React from 'react';
import { PieChart } from '@mui/x-charts/PieChart';
import SaveIcon from '@mui/icons-material/Save';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { Box, Typography, Button } from '@mui/material';
import * as XLSX from 'xlsx';

const SummaryChart = ({ chartHeader, pending, complete, rows }) => {
  console.log("esta pegando aqui")
  const data = [
    { label: 'Complete', value: complete, color: '#367c2b' },
    { label: 'Pending', value: pending, color: '#c21020' },
  ];

  const downloadExcel = () => {
    const ws = XLSX.utils.json_to_sheet(rows);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Excel supplier Data');
    XLSX.writeFile(wb, 'data.xlsx');
  };

  return (
    <>
      <Typography fontWeight="bold" component="p" gutterBottom sx={{ ml: 9 }}>
        {chartHeader}
      </Typography>

      <PieChart
        series={[{
          innerRadius: 60,

          data,
          
        }]}
        width={280}
        height={280}
        margin={{ top: 10, bottom: 10, left: 10, right: 10 }}
        hideLegend
      />

      <Box sx={{ pt: 5, pl: 8 }}>
        <Typography fontWeight="bold" color="#c21020" gutterBottom>
          <FiberManualRecordIcon sx={{ fontSize: '0.9rem' }} />&nbsp;&nbsp;&nbsp;Pending
        </Typography>
        <Typography fontWeight="bold" color="#367c2b" gutterBottom>
          <FiberManualRecordIcon sx={{ fontSize: '0.9rem' }} />&nbsp;&nbsp;&nbsp;Complete
        </Typography>
      </Box>

      <Box sx={{ pt: 4, pl: 8 }}>
        <Button
          startIcon={<SaveIcon />}
          onClick={downloadExcel}
          variant="outlined"
          sx={{ color: "#528b47", borderColor: "#528b47" }}
        >
          Export to Excel
        </Button>
      </Box>
    </>
  );
};

export default SummaryChart;
